import Text from 'components/_UI/Text';
import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';
import styled from 'styled-components';
import { Row } from 'styled/alignment/Row';
import colors from 'theme/colors';
import ExpirationModal from '../commom/ExpirationModal';
import { DEFAULT_RESERVATION_SECONDS } from '../commom/reservation';
import { useCheckout } from 'context/checkout/Checkout';

export default function TimeWarning({ setTime, onExpire }) {
    const { checkout } = useCheckout();

    // Fim da reserva gravado na criação do pedido, a partir do `expires_in` da
    // API. Sem ele (pedido criado por outro fluxo), o prazo padrão a partir de agora.
    const [endTime] = useState(() => checkout?.reservationEndsAt || Date.now() + DEFAULT_RESERVATION_SECONDS * 1000);
    const [timeLeft, setTimeLeft] = useState(() => Math.max(Math.floor((endTime - Date.now()) / 1000), 0));
    const [expirationModalVisible, setExpirationModalVisible] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            const remaining = Math.floor((endTime - Date.now()) / 1000);
            if (remaining > 0) {
                setTimeLeft(remaining);
                setTime(remaining);
            } else {
                clearInterval(interval);
                setTimeLeft(0);
                setExpirationModalVisible(true);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [setTime, endTime]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    return (
        <>
            <TimerBar>
                <TimerBadge>
                    <Clock size={16} color={colors.occasionalPurple} />
                </TimerBadge>
                <TimerTime>{formatTime(timeLeft)}</TimerTime>
                <TimerDescription>
                    Após este tempo, os ingressos serão liberados para venda novamente.
                </TimerDescription>
            </TimerBar>
            {expirationModalVisible && (
                <ExpirationModal visible={expirationModalVisible} onBack={onExpire} />
            )}
        </>
    );
}

const TimerBar = styled(Row)`
    margin-top: 20px;
    background: #F3EAFF;
    border: 1px solid ${colors.occasionalPurple}22;
    border-radius: 10px;
    padding: 12px 14px;
    align-items: center;
`;

const TimerBadge = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: ${colors.neutralLight};
    flex-shrink: 0;
`;

const TimerTime = styled.span`
    font-size: 15px;
    font-weight: 600;
    color: ${colors.occasionalPurple};
    margin: 0 10px;
    white-space: nowrap;
`;

const TimerDescription = styled.span`
    font-size: 13px;
    color: ${colors.night};
    line-height: 1.4;
`;
